import { Input as InputAnt } from 'antd';

export default InputAnt.TextArea;
